import { call, put, takeEvery } from "redux-saga/effects";
import { GET_DUTYTYPE } from "resources/actionTypes";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { dutyTypeApi } from "services/DutyType";

function* onDutyTypeSaga(action) {
  const payload = action.payload || {}
  const fetchDutyType =  yield call(dutyTypeApi, payload);

  if(fetchDutyType.success){
    yield put({ type: GET_DUTYTYPE.GET_DUTYTYPE_SUCCESS, fetchDutyType: fetchDutyType });
  }else{
    yield put({ type: GET_DUTYTYPE.GET_DUTYTYPE_FAILED, message: fetchDutyType.message });
      toast.error('Fetching Duty Type Failed');
  }
}

export function* onCompanyOnboardWatcher() {
  yield takeEvery(GET_DUTYTYPE.GET_DUTYTYPE_REQUESTED, onDutyTypeSaga);
}